import BaseService from './BaseService'

export default class extends BaseService {
  static index(options = {}) {
    const url = super.url("adulticides")

    if (options.page) {
      url.searchParams.append("page", options.page)
    }

    if(options.startDate) {
      url.searchParams.append("start_date", options.startDate)
    }

    if(options.endDate) {
      url.searchParams.append("end_date", options.endDate)
    }

    if(options.zoneId) { 
      url.searchParams.append("zone_id", options.zoneId)
    }

    if(options.truckId) {
      url.searchParams.append("truck_id", options.truckId)
    }

    if(options.contractId) {
      url.searchParams.append("contract_id", options.contractId)
    }

    if(options.applicatorId) {
      url.searchParams.append("applicator_id", options.applicatorId)
    }

    if(options.achemicalId) {
      url.searchParams.append("achemical_id", options.achemicalId)
    }

    return super.get(url).then(response => {
      return Promise.resolve(response.data)
    }).catch(error => {
      console.log(error)
      return Promise.reject(error.response.data)
    })
  }

  static filterOptions() {
    const url = super.url("adulticides/filter_options");

    return super.get(url).then(response => {
      return Promise.resolve(response.data)
    }).catch(error => {
      console.log(error)
      return Promise.reject(error.response.data)
    })
  }
}
